import CurdTable from "@/components/CurdTable.vue";
import SumTable from "@/components/SumTable.vue";

export default {
	data() {
		return {
			loadings: {
				main: false,
				filter: false,
			},
			sorts: {
				sortKey: "",
				sortOrder: "desc",
			},
			editorVisible: false,
			// 新加的
			editorVisibles: false,
			editorBatchVisible: false,
			editorId: "",
			editorIds: [],
			activeName: "list",
			batchConfirmInfo:{
				count:0,
				sum:0,
				recordIds:[]
			},
			//新的
			batchConfirmList:{
				count:0,
				sum:0,
				recordIds:[],
				showIds:[],
				showNames:[],
			},
			exportOptions: [{
				value: 0,
				label: '导出时无图片'
			}, {
				value: 1,
				label: '导出时有图片'
			}],
			exportValue: 0
		};
	},

	methods: {
		handleCreate() {
			this.editorId = "";
			this.editorVisible = true;
		},
		handleEdit(id) {
			this.editorId = id;
			this.editorVisible = true;
		},
		handleEditMulti(id) {
			this.editorIds = id;
			this.editorVisible = true;
		},
		handleSort(sorts) {
			this.sorts.sortKey = sorts.sortKey;
			this.sorts.sortOrder = sorts.sortOrder;
		},
		refreshTable(table) {
			if (!this.$refs[table]) {
				return;
			}
			this.$nextTick(() => {
				this.$refs[table].refreshData();
			});
		},
		handleClickBatchOp(key, checks) {
			let func = 'handleBatch_'+key;
			if (!this[func]) {
				alert(func+'方法不存在');
				return;
			}
			this[func]( checks);
		},
		// 多个发货方法
		handleClickList(key, checks){
			// console.log('来了999')
			this.handleList( checks)
		},
		doExport(dataModel, url = "", exportView = null, fieldsShow = null) {
			this.loadings.filter = true;
			if (!url) {
				url = `/curd/export/${dataModel}`;
			}
			if (!fieldsShow && this.$refs["listTable"]) {
				fieldsShow = this.$refs["listTable"].fieldsShow;
			}
			this.$axios
				.post(
					url,
					{
						page: this.hasPage ? this.paginations.main.pageNow : -999,
						sortKey: this.sorts.sortKey,
						sortOrder: this.sorts.sortOrder,
						searchFilter: this.searchFilter,
						dateFilter: this.dateFilter,
						kvFilter: this.kvFilter,
						view: exportView,
						fieldsShow: fieldsShow,
					},
					{ responseType: "arraybuffer" },
				)
				.then(res => {
					this.loadings.filter = false;

					let blob = new Blob([res], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
					});
					let objectUrl = URL.createObjectURL(blob);
					window.location.href = objectUrl;
				})
				.catch(res => {
					console.error(res);
					this.loadings.filter = false;

					// 错误信息
				});
		},
		doInventoryExport(dataModel, url = "", exportView = null, fieldsShow = null) {
			console.log(this.exportValue)
			this.loadings.filter = true;
			if (!url) {
				url = `/curd/export_inventory/${dataModel}`;
			}
			if (!fieldsShow && this.$refs["listTable"]) {
				fieldsShow = this.$refs["listTable"].fieldsShow;
			}
			this.$axios.defaults.withCredentials = true // 若跨域请求需要带 cookie 身份识别
			this.$axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
			this.$axios
				.post(
					url,
					{
						page: this.hasPage ? this.paginations.main.pageNow : -999,
						sortKey: this.sorts.sortKey,
						sortOrder: this.sorts.sortOrder,
						searchFilter: this.searchFilter,
						dateFilter: this.dateFilter,
						kvFilter: this.kvFilter,
						view: exportView,
						fieldsShow: fieldsShow,
						exportValue: this.exportValue
					},
					{ responseType: "arraybuffer" },
				)
				.then(res => {
					this.loadings.filter = false;

					let blob = new Blob([res], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
					});
					let objectUrl = URL.createObjectURL(blob);
					window.location.href = objectUrl;
				})
				.catch(res => {
					console.error(res);
					this.loadings.filter = false;

					// 错误信息
				});
		},

		doSaleExport(dataModel, activeName = "", filterDateSlot = null, fieldsShow = null, url) {
			this.loadings.filter = true;
			url = 'analyse/sales_export/'+activeName+'/'+filterDateSlot;

			if (!fieldsShow && this.$refs["sumGroupTable"]) {
				fieldsShow = this.$refs["sumGroupTable"].fieldsShow;
			}
			this.$axios.defaults.withCredentials = true // 若跨域请求需要带 cookie 身份识别
			this.$axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
			this.$axios
				.post(
					url,
					{
						page: this.hasPage ? this.paginations.main.pageNow : -999,
						sortKey: this.sorts.sortKey,
						sortOrder: this.sorts.sortOrder,
						searchFilter: this.searchFilter,
						dateFilter: this.dateFilter,
						kvFilter: this.kvFilter,
						fieldsShow: [],
					},
					{ responseType: "arraybuffer" },
				)
				.then(res => {
					this.loadings.filter = false;

					let blob = new Blob([res], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
					});
					let objectUrl = URL.createObjectURL(blob);
					window.location.href = objectUrl;
				})
				.catch(res => {
					console.error(res);
					this.loadings.filter = false;

					// 错误信息
				});
		},

		doContrastExport(dataModel, url = "", exportView = null, fieldsShow = null) {
			this.loadings.filter = true;
			if (!url) {
				url = `/inventory/list_all_stocks_contrast_export/${dataModel}`;
			}
			if (!fieldsShow && this.$refs["listTable"]) {
				fieldsShow = this.$refs["listTable"].fieldsShow;
			}
			this.$axios.defaults.withCredentials = true // 若跨域请求需要带 cookie 身份识别
			this.$axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
			this.$axios
				.post(
					url,
					{
						page: this.hasPage ? this.paginations.main.pageNow : -999,
						sortKey: this.sorts.sortKey,
						sortOrder: this.sorts.sortOrder,
						searchFilter: this.searchFilter,
						dateFilter: this.dateFilter,
						kvFilter: this.kvFilter,
						view: exportView,
						fieldsShow: fieldsShow,
					},
					{ responseType: "arraybuffer" },
				)
				.then(res => {
					this.loadings.filter = false;

					let blob = new Blob([res], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
					});
					let objectUrl = URL.createObjectURL(blob);
					window.location.href = objectUrl;
				})
				.catch(res => {
					console.error(res);
					this.loadings.filter = false;

					// 错误信息
				});
		},


	},
	components: {
		CurdTable,
		SumTable,
	},
	watch: {},
};
